<template>
  <div v-if="isEmbedded" class="app-bar-nav">
    <surface-builder />
    <SurfaceNavEmbedActions />
  </div>
  <div v-else class="app-bar-nav surface-nav relative">
    <a href="/?ref=logo" class="logo" target="_top" role="button" :title="__('Take me home')"
      ><div class="logo-image" :aria-label="__('Take me home')"
    /></a>
    <surface-activity-indicator
      v-if="xNewComposerModalPanel && !isIPadOS"
      class="static sm:absolute sm:left-1/2 sm:transform sm:-translate-x-1/2"
    />
    <menu v-if="showMenuActions" class="app-bar-menu">
      <li>
        <surface-activity-indicator v-if="xNewComposerModalPanel && isIPadOS" class="static px-2" />
      </li>
      <li v-if="!userRegistered" class="globalnav-signup">
        <a role="button" :href="signupPath" class="app-bar-button">{{ __('Sign up') }}</a>
      </li>
      <li v-if="!userRegistered" class="globalnav-login">
        <a role="button" :href="loginPath" class="app-bar-button">{{ __('Log in') }}</a>
      </li>
      <SurfaceNavBookmarkButton v-if="canILikeWall" />
      <li v-if="canIRemake">
        <button class="app-bar-button app-bar-icon-text-button" :title="__('Remake')" @click="showRemakePanelTracked">
          <base-icon name="remake" /><span class="responsive-no-phone-only">{{ __('Remake') }}</span>
        </button>
      </li>
      <li>
        <button
          class="app-bar-button app-bar-icon-text-button"
          :title="__('Share/Export/Embed')"
          @click="toggleSharePanelTracked"
        >
          <base-icon name="share_arrow" /><span class="responsive-no-phone-only">{{ __('Share') }}</span>
        </button>
      </li>
      <li v-if="canModify">
        <button class="app-bar-button" :title="__('Modify')" @click="toggleSettingsPanelTracked">
          <base-icon name="settings" />
        </button>
      </li>
      <li v-if="!userRegistered" class="globalnav-help">
        <a
          role="button"
          class="app-bar-button"
          href="https://padlet.helpdocs.io/"
          target="_blank"
          :title="__('Get help')"
        >
          <base-icon name="help_outline" />
        </a>
      </li>
      <li class="globalnav-more">
        <button
          id="globalnav-more-menu-button"
          class="app-bar-button"
          aria-haspopup="true"
          :aria-expanded="xToolMenu"
          aria-owns="globalnav-more-menu"
          aria-controls="globalnav-more-menu"
          :title="__('More')"
          @click="toggleToolMenuTracked"
        >
          <base-icon name="more_horiz" />
        </button>
        <menu
          v-if="xToolMenu"
          id="globalnav-more-menu"
          class="dropdown dropdown-with-curtain"
          role="group"
          aria-labelledby="globalnav-more-menu-button"
          @click="hideToolMenu"
        >
          <div class="dropdown-content action-list">
            <a v-if="!userRegistered" href="/auth/signup" class="list-item" tabindex="0" :title="__('Sign up')">
              <base-icon name="sign_up" /> <span>{{ __('Sign up') }}</span>
            </a>
            <a v-if="!userRegistered" href="/auth/login" class="list-item" tabindex="0" :title="__('Log in')">
              <base-icon name="fingerprint" /> <span>{{ __('Log in') }}</span>
            </a>
            <div v-if="!userRegistered" class="divider" />
            <div class="list-item" role="button" tabindex="0" :title="__('About this padlet')" @click="showInfoTracked">
              <base-icon name="info_outline" /> <span>{{ __('Info') }}</span>
            </div>
            <a
              class="list-item"
              role="button"
              href="https://padlet.helpdocs.io/"
              target="_blank"
              tabindex="0"
              :title="__('Get help')"
            >
              <base-icon name="help_outline" /> <span>{{ __('Help') }}</span>
            </a>
            <SurfaceNavBookmarkMenuRow v-if="canILikeWall" />
            <div
              v-if="canIRemake"
              class="list-item"
              role="button"
              tabindex="0"
              :title="__('Remake')"
              @click="showRemakePanelTracked"
            >
              <base-icon name="remake" /> <span>{{ __('Remake') }}</span>
            </div>
            <div
              v-if="canGoFullscreen && !isFullscreen"
              class="list-item"
              role="button"
              tabindex="0"
              :title="__('Enter full screen')"
              @click="enterFullscreenTracked"
            >
              <base-icon name="fullscreen" /> <span>{{ __('Enter full screen') }}</span>
            </div>
            <div
              v-if="canGoFullscreen && isFullscreen"
              class="list-item"
              role="button"
              tabindex="0"
              :title="__('Exit full screen')"
              @click="exitFullscreen"
            >
              <base-icon name="fullscreen" /> <span>{{ __('Exit full screen') }}</span>
            </div>
            <div v-if="canModify || canClone" class="divider" />
            <div
              v-if="canInvite"
              class="list-item"
              role="button"
              tabindex="0"
              :title="__('Invite people')"
              @click="goToInvite"
            >
              <base-icon name="group_add" /> <span>{{ __('Invite people') }}</span>
            </div>
            <div class="list-item" role="button" tabindex="0" :title="__('Share or embed')" @click="goToShare">
              <base-icon name="share" /> <span>{{ __('Share or embed') }}</span>
            </div>
            <div class="list-item" role="button" tabindex="0" :title="__('Export')" @click="goToExport">
              <base-icon name="export" /> <span>{{ __('Export') }}</span>
            </div>
            <div class="list-item" role="button" tabindex="0" :title="__('Print')" @click="print">
              <base-icon name="print" /> <span>{{ __('Print') }}</span>
            </div>
            <div v-if="canModify || canClone" class="divider" />
            <div
              v-if="canModify"
              class="list-item"
              role="button"
              :title="__('Modify')"
              @click="toggleSettingsPanelTracked"
            >
              <base-icon name="settings" /> <span>{{ __('Modify') }}</span>
            </div>
            <div
              v-if="canModify"
              class="list-item"
              role="button"
              :title="__('Change format')"
              @click="showConvertLayoutPanelTracked"
            >
              <base-icon name="change_format" /> <span>{{ __('Change format') }}</span>
            </div>
            <div
              v-if="canModify"
              class="list-item"
              role="button"
              :title="__('Clear all posts')"
              @click="showClearAllDialogTracked"
            >
              <base-icon name="erase" /> <span>{{ __('Clear all posts') }}</span>
            </div>
            <div v-if="canModify" class="list-item" role="button" :title="__('Archive')" @click="archiveWallTracked">
              <base-icon name="archive" /> <span>{{ __('Archive') }}</span>
            </div>
            <div
              v-if="canModify"
              class="list-item"
              role="button"
              :title="__('Delete')"
              @click="showDeleteDialogTracked"
            >
              <base-icon name="delete" /> <span>{{ __('Delete') }}</span>
            </div>
          </div>
        </menu>
      </li>
      <li v-if="userRegistered" class="globalnav-user-avatar">
        <app-bar-account
          :user="user"
          @upgrade="userTriggeredUpgrade({ user: user, upgradeSource: UpgradeSource.SurfaceProfileClick })"
        />
      </li>
    </menu>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapState, mapGetters, mapActions } from 'vuex'
import AppBarAccount from 'vuecomponents/app_bar_account'
import BaseIcon from 'vuecomponents/base_icon'
import SurfaceBuilder from 'vuecomponents/surface_builder'
import SurfaceNavEmbedActions from 'vuecomponents/SurfaceNavEmbedActions'
import SurfaceNavBookmarkButton from 'vuecomponents/SurfaceNavBookmarkButton'
import SurfaceNavBookmarkMenuRow from 'vuecomponents/SurfaceNavBookmarkMenuRow'
import SurfaceActivityIndicator from 'vuecomponents/surface-activity-indicator'
import { isFullscreenAvailable } from 'bits/fullscreen'
import { currentUrl } from 'bits/location'
import { trackEvent } from 'bits/analytics'
import { ShareSubpanel } from 'vuexstore/modules/share'
import { UpgradeSource } from 'vuexstore/modules/plans'

export default {
  components: {
    BaseIcon,
    SurfaceBuilder,
    SurfaceNavEmbedActions,
    SurfaceNavBookmarkButton,
    SurfaceNavBookmarkMenuRow,
    SurfaceActivityIndicator,
    AppBarAccount,
  },
  data() {
    return { UpgradeSource }
  },
  computed: {
    ...mapState([
      'isEmbedded',
      'user',
      'panel',
      'isReadOnly',
      'xToolMenu',
      'isLikedByCurrentUser',
      'isIOS',
      'isTablet',
    ]),
    ...mapGetters('browser', ['isFullscreen']),
    ...mapGetters(['canIAdminister', 'canIRemake', 'links', 'canILikeWall', 'xNewComposerModalPanel', 'isLibraryWall']),
    isIPadOS() {
      return this.isIOS && this.isTablet
    },
    userRegistered() {
      return !!this.user.registered_at
    },
    canModify() {
      return this.canIAdminister
    },
    canClone() {
      return this.canIAdminister
    },
    canInvite() {
      return this.canIAdminister
    },
    isLiked() {
      return this.isLikedByCurrentUser
    },
    canGoFullscreen() {
      return isFullscreenAvailable
    },
    printLink() {
      return this.links.print
    },
    showMenuActions() {
      return !this.isReadOnly
    },
    signupPath() {
      return `/auth/signup?next=${encodeURIComponent(currentUrl())}`
    },
    loginPath() {
      return `/auth/login?next=${encodeURIComponent(currentUrl())}`
    },
  },
  methods: {
    ...mapActions([
      'showInfo',
      'archiveWall',
      'toggleToolMenu',
      'showRemakePanel',
      'showConvertLayoutPanel',
      'showDeleteDialog',
      'showClearAllDialog',
      'hideToolMenu',
    ]),
    ...mapActions('plans', ['userTriggeredUpgrade']),
    ...mapActions('browser', ['enterFullscreen', 'exitFullscreen']),
    ...mapActions('share', ['toggleSharePanel']),
    ...mapActions('settings', ['toggleSettingsPanel']),
    goToInvite() {
      this.toggleSharePanel(ShareSubpanel.Members)
    },
    goToShare() {
      return this.goToExport()
    },
    goToExport() {
      this.toggleSharePanel(ShareSubpanel.Main)
    },
    print() {
      trackEvent('Surface', 'Nav Clicked', 'Print')
      window.open(this.printLink)
    },
    enterFullscreenTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Fullscreen')
      this.enterFullscreen()
    },
    toggleSettingsPanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Settings')
      this.toggleSettingsPanel()
    },
    toggleSharePanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Share')
      this.toggleSharePanel(ShareSubpanel.Main)
    },
    showRemakePanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Remake')
      this.showRemakePanel()
    },
    toggleToolMenuTracked() {
      trackEvent('Surface', 'Nav Clicked', 'More')
      this.toggleToolMenu()
    },
    showConvertLayoutPanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Change Layout')
      this.showConvertLayoutPanel()
    },
    showDeleteDialogTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Delete')
      this.showDeleteDialog()
    },
    showClearAllDialogTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Clear')
      this.showClearAllDialog()
    },
    showInfoTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Info')
      this.showInfo()
    },
    archiveWallTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Archive')
      this.archiveWall()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/3/modules/all';

.app-bar-menu {
  display: flex;
  align-items: center;

  & > li {
    list-style-type: none;
  }
}

.app-bar-button {
  background: none;
  border: none;
  padding: 0 8px;
  color: inherit;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 32px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  color: $caption-text-color;
  color: var(--caption-text-color);

  @include hover {
    color: $body-text-color;
    color: var(--body-text-color);
  }
}
</style>
